import React from 'react';
import PropTypes from 'prop-types';

export default function VideoComponent({ component, mediaStyle }) {
	const { vidtype, vidid } = component;
	const containerStyle = {};
		if(mediaStyle?.component_bottom_margin) {
			containerStyle.marginBottom = `${mediaStyle.component_bottom_margin}px`
		}
	switch (vidtype) {
		case 'youtube':
			return (
				<iframe
					width="100%"
					title={'Video'}
					style={containerStyle}
					height="400"
					src={`https://www.youtube.com/embed/${vidid}`}
					frameBorder="0"
					allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
					allowFullScreen
				/>
			);
		case 'vimeo':
			return (
				<iframe
					title={'Video'}
					src={`https://player.vimeo.com/video/${vidid}`}
					width="100%"
					height="400"
					style={containerStyle}
					frameBorder="0"
					allow="autoplay; fullscreen"
					allowFullScreen
				/>
			);
		default:
			return null;
	}
}

VideoComponent.propTypes = {
	component: PropTypes.object.isRequired,
	mediaStyle: PropTypes.object
};